export const siteSettings = {
  name: "Smart Vest Plus",
  link: "https://smartvestplus.com",
  email: "support@smartvestplus.com",
  appLink: "https://app.smartvestplus.com",
};
